import r from "r-dom";
import AdminActivationReport, {
  Props,
} from "../components/widgets/AdminActivationReport/AdminActivationReport";
import { withApollo } from "../graphql/client";

export default function AdminActivationReportApp(props: Props) {
  return withApollo(r(AdminActivationReport, props));
}
